<template>
  <div class="geolocation-component">
    <v-dialog content-class="expand geolocation-dialog" persistent v-model="show">
      <div class="header">
        <v-layout align-center>
          <v-flex>
            <h1 v-if="message.errorCode !== 'softGeolocation' && message.errorCode !== 'softGeolocationRedirect' && message.errorCode !== 'hardGeolocationRedirect'">{{ $t('Geolocation.ErrorMessage.Header') }}</h1>
            <h1 v-if="message.errorCode === 'softGeolocation'">{{ $t('softGeolocation.ErrorMessage.Header') }}</h1>
            <h1 :class="[message.errorCode]" v-if="message.errorCode === 'softGeolocationRedirect' || (message.errorCode === 'hardGeolocationRedirect' && message.params.locationSuccess)">{{ $t('softGeolocationRedirect.infoMessage.Header') }}</h1>
            <h1 :class="[message.errorCode]" v-if="message.errorCode === 'hardGeolocationRedirect' && !message.params.locationSuccess">{{ $t('hardGeolocationRedirect.infoMessage.Header') }}</h1>
          </v-flex>
        </v-layout>
      </div>
      <div class="geo-content">
        <v-layout align-center>
          <v-flex v-if="message.errorCode !== 'softGeolocation' && message.errorCode !== 'softGeolocationRedirect'&& message.errorCode !== 'hardGeolocationRedirect'">
              <p>{{ $t('Geolocation.ErrorCode.'+ message.errorCode + '.' +state) }}</p>
              <div v-if="message.errorCode === 612 || message.errorCode === 615">
                <a class="gc-link" @click.stop="pluginDownload()">{{ $t('GeoComply.client.pluginDownload') }}</a>
                <p v-if="message.errorCode === 615" style="margin-top: 10px"><i>{{ $t('Geolocation.ErrorCode.Note') }}</i></p>
              </div>
            <p class="geo-suggestion">{{ $t('Geolocation.ErrorCode.suggestion') }}</p>
          </v-flex>
          <v-flex v-if="message.errorCode === 'softGeolocation'">
              <p>{{ $t('Geolocation.ErrorCode.' + message.errorCode) }}</p>
              <div class="softGeolocationLinks">
                <div class="state-wrapper">
                  <h2 class="state-link"><a @click="goToSite('NJ')">New Jersey</a></h2>
                  <h2 class="state-link"><a @click="goToSite('WV')">West Virginia</a></h2>
                </div>
              </div>
          </v-flex>
          <v-flex v-if="message.errorCode === 'softGeolocationRedirect'">
              <p>{{ $t('softGeolocationRedirect.infoMessage.Text') }}</p>
          </v-flex>
        </v-layout>
      </div>
      <div class="geo-content" v-if="message.errorCode !== 'softGeolocation' && message.errorCode !== 'hardGeolocationRedirect'">
        <div class="buttons">
          <v-btn v-if="message.errorCode !== 'softGeolocationRedirect'" block @click.stop="closeDialog()" class="primary-btn-blue">
            <span>{{ $t('Geolocation.ErrorMessage.OK') }}</span>
          </v-btn>
          <v-btn v-if="message.errorCode === 'softGeolocationRedirect'" block @click.stop="goToRedirect(message.pathAndState.stateISO)" class="primary-btn-blue">
            <span>{{ $t('Geolocation.ErrorMessage.Continue') }}</span>
          </v-btn>
          <div class="nothx">
              <a v-if="message.errorCode === 'softGeolocationRedirect'" class="app-btn" @click="closeDialog()">{{ $t('Geolocation.ErrorMessage.NoThx') }}</a>
            </div>
        </div>
      </div>
      <div class="geo-content" v-if="message.errorCode === 'hardGeolocationRedirect'">
        <v-flex >
          <p v-if="message.params.locationSuccess">{{ $t('hardGeolocationRedirect.infoMessage.Text.' + message.params.redirectTo) }}</p>
          <p v-if="!message.params.locationSuccess">{{ $t('hardGeolocationRedirect.infoMessage.FailedText.' + state) }}</p>
        </v-flex>
        <div class="buttons">
          <v-btn block @click.stop="goToSite(message.params.redirectTo)" class="primary-btn-blue">
            <span>{{ $t('Geolocation.ErrorMessage.Continue') }}</span>
          </v-btn>
          <div class="nothx">
            <a class="app-btn" @click="closeDialog()">{{ $t('Geolocation.ErrorMessage.NoThx.' + message.params.redirectTo) }}</a>
          </div>
        </div>
      </div>

    </v-dialog>
  </div>
</template>
<script>
  import store from '@/store'
  import config from '@/config'
  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'geolocation-component',

    mixins: [
      Screen
    ],

    data () {
      return {
        show: true,
        message: ''
      }
    },

    computed: {
      geolocationMessage () {
        return store.getters['overlayState/getGeolocationMessage']
      },
      gcInstallerUrl () {
        var gcData = {}
        if (process.env.NODE_ENV === 'development') {
          gcData = {url: 'stg-ums.geocomply.net', id: 'Ac7VjeFkEw'}
          return gcData
        } else if (process.env.NODE_ENV === 'production') {
          gcData = {url: 'ums.geocomply.com', id: 'LW2BYMiQ3R'}
          return gcData
        } else {
          gcData = {url: 'stg-ums.geocomply.net', id: 'Ac7VjeFkEw'}
          return gcData
        }
      },
      navigatorID () {
        if (navigator.appVersion.indexOf('Win') !== -1) {
          return 'win'
        } else if (navigator.appVersion.indexOf('Mac') !== -1) {
          return 'mac'
        } else {
          return undefined
        }
      },
      state () {
        return window.ctsautoconf.STATE
      },
      externalUrls () {
        return config.externalUrls
      }
    },

    methods: {
      closeDialog () {
        this.show = !this.show
      },
      pluginDownload () {
        window.location = 'https://' + this.externalUrls.geocomplyPluginURL + '/installer/url?id=' + this.externalUrls.geocomplyInstallerKey + '&os=' + this.navigatorID + '&version=' + this.externalUrls.geocomplyPluginVersion + '&user_id=' + this.message.userID
      },
      goToSite (state) {
        switch (state) {
          case 'NJ':
            window.open(window.ctsautoconf.NEWJERSEY, '_self')
            break
          case 'WV':
          case '00':
            window.open(window.ctsautoconf.WESTVIRGINIA, '_self')
        }
      },
      goToRedirect (state) {
        var optionalISOStates = ['WV', 'LND', 'LCY', 'LA', 'CA', 'NY', 'IE', 'L']
        if (optionalISOStates.includes(state)) {
          window.open(window.ctsautoconf.WESTVIRGINIA, '_self')
        }
      }
    },
    mounted () {
      this.message = this.geolocationMessage
    }
  }
</script>
<style lang="stylus" scoped>
@import '~@/css/config';

.geolocation-dialog {
  font-family: font-family-igt;
  background: transparent;
  padding: 0px;
  border-radius: 4px;

  .header {
    padding: 36px 36px 9px 36px;
  }

  h1 {
    margin: 0;
    text-transform: uppercase;
    font-size: 30px;
    line-height: 35px;
    font-weight: bold;
    color: #E24447;
  }

  .geo-content {
    line-height: 20px;
    text-align: left;
    color: #818e95;
    padding: 0px 36px;
    font-size: 14px;
    .geo-suggestion {
      margin-top: 20px;
      color: #e24447;
    }

    .buttons {
      padding-bottom: 20px;

      .primary-btn-blue {
        background-color: #1493FF !important;
        border-radius: 2px;

        .btn {
          span {
            font-weight: normal !important;
          }
        }
      }
    }
  }
}

.softGeolocationLinks
  .state-wrapper
    display flex
    padding-bottom 16px
    .state-link
      display flex
      flex-grow 6
      text-transform uppercase
      font-weight bold
      color: #1493ff

.softGeolocationRedirect
  color: #1f375b !important
.nothx
  text-align: center
  padding-top: 10px
  a
    color: #1f375b
    font-size: 14px
    line-height: 16px
</style>



// WEBPACK FOOTER //
// src/components/common/GeolocationMessage.vue